// SkillItem, LegacySkillItem 두 타입에 공통적으로 존재하는 'value' 속성을 가지는 타입 정의
const t=t=>t.length<=1?t:t.sort(((t,e)=>{const a=/^[^a-zA-Z0-9가-힣]/,l=/^[0-9]/,s=/^[A-Za-z]/,o=/^[가-힣]/,r=t=>a.test(t)?0:l.test(t)?1:s.test(t)?2:o.test(t)?3:4,u=r(t.value),n=r(e.value);// 영어, 숫자, 한글이 아닌 모든 문자
return u!==n?u-n:t.value.localeCompare(e.value);
// 같은 유형일 경우 값에 따라 사전순 정렬
}));export{t as getSortedSkillItems};
